import React from "react";

const Haulage = () => {
  return (
    <div>
      <div className="container mx-auto pt-24 md:pt-36 pb-12 px-5 text-black">
        <div className="flex flex-col">
          <div className="flex flex-col md:flex-row gap-y-3 items-start">
            <div className="flex items-center text-4xl font-bold head gap-3 md:w-[30%]">
              <span className="text-pry">HAULAGE</span>
              <div className="h-2 w-4 bg-black"></div>
            </div>
            <div className="md:w-[60%]">
              Cross Country Haulage offer a local, national and international
              haulage services with total reliability guaranteed. Our expertise
              within the Transportation industry has enabled us to become the
              haulier of choice for many companies within transportation
              community, as well as offering a wide range of services to
              business and industry. <br />
              <br /> We are one of the longest standing haulage companies in
              Nigeria. Since 2001, we have provided clients with the peace of
              mind that comes with knowing that your goods will be delivered on
              time, and with no issues. Our professional staffs have many years
              of experience and understand how to get your goods to their
              destination as quickly and efficiently as possible. This takes
              huge pressure off your shoulders and will allow you to concentrate
              on other aspects of your business, safe in the knowledge that your
              goods are in safe hands. <br />
              <br /> At Cross Country Haulage, we offer our clients a huge range
              of haulage services and solutions that meet the transport
              requirements of an individual or companies of any size throughout
              Africa with our head office situated at 345, Murtala Muhammed Way,
              Lagos. We are perfectly placed to deliver your goods anywhere in
              Nigeria.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Haulage;
